import React from "react";
import { useTranslation } from "react-i18next";

import ErrorState from "../common/errorState";
import styles from "./accountUnavailable.module.css";

/**
 * Shown in place of the member area when the member is signed in with Keycloak but the backend has no account for
 * the identity (a refused or an unprovisioned identity, GROWTH-7362). Nothing here is signed out for the member:
 * signing out at Keycloak ends their session in every Heritage Web app, so it is their choice, through "Log Out".
 *
 * @param {Object} props
 * @param {string|null} props.requestId id of the request the backend refused; support searches the logs for it
 * @returns {JSX.Element}
 */
const AccountUnavailable = ({ requestId }) => {
  const { t } = useTranslation();

  return (
    <main className={styles.page}>
      <ErrorState
        message={t("dashboard_account_unavailable_message")}
        requestId={requestId}
        backTo="/logout"
        backLabel={t("dashboard_nav_logout")}
      />
    </main>
  );
};

export default AccountUnavailable;
